/* p7-card-filter.js — one size filter for every server-rendered card page.
   Collection, search and related. The homepage has its own in p7-sale.js,
   because it renders its cards from the payload rather than from Liquid.

   Reads a card's sizes from the size chips already in its DOM. There is no
   data-sizes attribute: it would state the same run twice per card and could
   disagree with the chips rendered beside it.

   Every piece of chrome is optional. A page with cards and nothing else still
   filters; a page with a rail gets a rail. No page detection anywhere.
*/
(function () {
  'use strict';

  // Two identical <script src> tags are fetched once but EXECUTED twice.
  // The drop template loads this file from two sections; without this the
  // delegated chip listener binds twice and every size tap toggles on-off.
  if (window.__p7CardFilterInit) return;
  window.__p7CardFilterInit = true;

  var P = window.P7SizePrefs;
  if (!P) return;   // vocabulary owner missing — do nothing rather than guess

  function cardSizes(card) {
    return Array.prototype.slice
      .call(card.querySelectorAll('[data-size-chip]'))
      .filter(function (chip) { return !chip.classList.contains('is-out'); })
      .map(function (chip) { return chip.getAttribute('data-size') || ''; })
      .filter(Boolean);
  }

  function isShoeCard(card) {
    return card.getAttribute('data-ptype') === 'shoe';
  }

  // The element to hide. On collection/search the card sits inside an
  // <li class="p7-clx__cell"> that owns the grid layout (p7-collection.liquid,
  // p7-search.liquid), so hiding the <article> alone would leave a gap in the
  // row. The related rail (p7-product-related.liquid) has no such wrapper —
  // .p7-related-products__grid is a CSS grid straight on the cards — so the
  // card itself is the right target there, which is what the fallback gives.
  function hideTarget(card) {
    return card.closest('.p7-clx__cell') || card;
  }

  // The server renders collection.products_count, which counts merged
  // parents and kids that the card loop skips and that can never appear —
  // 87 where only 72 are reachable. meta.emitted is what the page can
  // actually show. Search and the related rail have no payload, so they
  // keep their server text (readEmittedTotal returns null and the caller
  // falls back). Parsed once and memoized — shared with boot()'s
  // beyond-the-page renderer below, so the payload is never parsed twice —
  // because a broken/absent payload must not break filtering: a bad parse
  // just resolves to null forever rather than being retried every apply().
  var payload;
  var payloadResolved = false;
  function readPayload() {
    if (payloadResolved) return payload;
    payloadResolved = true;
    payload = null;
    var el = document.getElementById('p7-clx-data');
    if (el) {
      try { payload = JSON.parse(el.textContent); } catch (e) { /* malformed payload */ }
    }
    return payload;
  }

  function readEmittedTotal() {
    var data = readPayload();
    return (data && data.meta && typeof data.meta.emitted === 'number') ? data.meta.emitted : null;
  }

  function boot() {
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-card]'));

    // rail/countEl/emptyEl are deliberately NOT captured here. On collection
    // and search they exist synchronously at boot, but the related rail's
    // chrome is rendered INSIDE [data-p7-recommendations-content], which does
    // not exist yet at boot time on a PDP (recommendations.performed is false
    // until p7-recommendations.js's fetch lands) and is then REPLACED
    // wholesale on every subsequent fetch. A reference captured once here
    // would be null on arrival and stale forever after — so each is
    // re-queried on every apply()/renderRail() pass instead.
	  var countInitialText = null;   // set on the first non-null countEl sighting
	  var state = P.normalize(P.read());
	  var pag = document.querySelector('[data-clx-pagination]');
	  var root = document.querySelector('[data-clx-handle]');
	  var collectionHandle = root ? String(root.getAttribute('data-clx-handle') || '').trim().toLowerCase() : '';
	  var collectionTitle = root ? String(root.getAttribute('data-clx-title') || '').trim() : '';
	  var categoryFilter = 'all';

    // A collection page paginates the DOM (per_page) but the payload above
    // carries the whole collection (up to the 250 cap). Without this, a
    // filter hides the non-matches on page 1 and never surfaces the matches
    // sitting on page 3 — the shopper concludes the size isn't stocked.
    var payload = readPayload();
    var onPage = {};
    cards.forEach(function (c) { onPage[String(c.getAttribute('data-pid'))] = true; });

    // JS-rendered matches are appended to the same <ul>, so they inherit the
    // grid's layout for free. Tracked in their own array rather than mixed
    // into `cards`, so the server-card list never has to be re-queried and a
    // JS card can never be mistaken for one Liquid rendered.
	  var grid = document.getElementById('p7-clx-grid');
	  var overflowNodes = [];
	  var productsById = {};
	  if (payload && Array.isArray(payload.products)) {
	    payload.products.forEach(function (p) {
	      productsById[String(p.id)] = p;
	    });
	  }

	  var MODEL_FILTERS = [
	    { key: 'all', label: 'All' },
	    { key: 'model:aran', label: 'Aran', model: 'aran' },
	    { key: 'model:cambridge', label: 'Cambridge', model: 'cambridge' },
	    { key: 'model:telford', label: 'Telford', model: 'telford' },
	    { key: 'model:essex', label: 'Essex', model: 'essex' },
	    { key: 'model:manchester', label: 'Manchester', model: 'manchester' },
	    { key: 'model:conrad', label: 'Conrad', model: 'conrad' }
	    // Payload retired 2026-08-27 (Aran took the slot). No pill: the three
	    // Payload children still published sit under All until Phase E
	    // unpublishes them (owner-gated Admin work).
	  ];
	  var MODEL_HANDLES = MODEL_FILTERS
	    .filter(function (f) { return f.model; })
	    .map(function (f) { return f.model; });
	  var BUCKET_FILTERS = [
	    { key: 'all', label: 'All' },
	    { key: 'bucket:new', label: 'New', buckets: ['new'] },
	    { key: 'bucket:sale', label: 'Sale', buckets: ['evergreen', 'sale'] },
	    { key: 'bucket:final', label: 'Final', buckets: ['last-season', 'final'] },
	    { key: 'series:elite', label: 'Elite', elite: true }
	  ];
	  // Mixed collections (sale). Category comes from the payload's `type`
	  // (shoe / apparel) and `category` (product.type), so no handle or menu
	  // is consulted and the pills never navigate. Both size sets stay live:
	  // shoe cards filter by the remembered shoe size, apparel by apparel size.
	  var CATEGORY_FILTERS = [
	    { key: 'all', label: 'All' },
	    { key: 'cat:shoes', label: 'Shoes', cat: 'shoes' },
	    { key: 'cat:apparel', label: 'Apparel', cat: 'apparel' },
	    { key: 'cat:accessories', label: 'Accessories', cat: 'accessories' }
	  ];
	  function productCategory(p) {
	    if (!p) return '';
	    if (p.type === 'shoe') return 'shoes';
	    var c = String(p.category || '').trim().toLowerCase();
	    return c === 'accessories' ? 'accessories' : 'apparel';
	  }

	  function clearOverflow() {
      overflowNodes.forEach(function (n) {
        if (n.parentNode) n.parentNode.removeChild(n);
      });
      overflowNodes = [];
	  }

	  function pageFilterMode() {
	    if (collectionHandle === 'sale') {
	      return 'sale';
	    }
	    if (collectionHandle === 'all' || collectionHandle === 'shoes' || collectionHandle === 'all-products-in-stock') {
	      return 'model';
	    }
	    // apparel-warehouse: the 2026-10-01 clearance page, all apparel.
	    if (collectionHandle === 'apparel' || collectionHandle === 'apparel-warehouse') {
	      return 'apparel-size';
	    }
	    return MODEL_HANDLES.indexOf(collectionHandle) !== -1 ? 'bucket' : '';
	  }

	  function activeSizeState() {
	    var mode = pageFilterMode();
	    if (mode === 'apparel-size') return { s: [], a: state.a || [] };
	    if (mode === 'model' || mode === 'bucket') return { s: state.s || [], a: [] };
	    if (mode === 'sale') return { s: state.s || [], a: state.a || [] };
	    return { s: state.s || [], a: state.a || [] };
	  }

	  function productModel(p) {
	    return String((p && p.model) || '').trim().toLowerCase();
	  }

	  function matchesModelFilter(p, model) {
	    var target = String(model || '').trim().toLowerCase();
	    if (!target) return true;
	    var modelValue = productModel(p);
	    // The model metafield is the authority. Handle and title are ONLY a
	    // fallback for a product with no model set: the Aran colourways kept
	    // their "payload-*" handles from before the rename, and matching on
	    // handle put a Payload pill back on Shoes (2026-09-07).
	    if (modelValue) return modelValue === target || modelValue.indexOf(target) !== -1;
	    var handle = String((p && p.handle) || '').toLowerCase();
	    var title = String((p && p.title) || '').toLowerCase();
	    return handle.indexOf(target) !== -1 || title.indexOf(target) !== -1;
	  }

	  function productBucket(p) {
	    return String((p && p.bucket) || '').trim().toLowerCase();
	  }

	  function matchesBucket(p, buckets) {
	    var value = productBucket(p);
	    return (buckets || []).indexOf(value) !== -1;
	  }

	  function matchesCategory(p) {
	    if (!p || categoryFilter === 'all') return true;
	    if (categoryFilter.indexOf('model:') === 0) {
	      return matchesModelFilter(p, categoryFilter.slice(6));
	    }
	    if (categoryFilter.indexOf('cat:') === 0) {
	      return productCategory(p) === categoryFilter.slice(4);
	    }
	    if (categoryFilter === 'bucket:new') {
	      return matchesBucket(p, ['new']);
	    }
	    if (categoryFilter === 'bucket:sale') {
	      return matchesBucket(p, ['evergreen', 'sale']);
	    }
	    if (categoryFilter === 'bucket:final') {
	      return matchesBucket(p, ['last-season', 'final']);
	    }
	    if (categoryFilter === 'series:elite') {
	      return !!p.elite;
	    }
	    return true;
	  }

	  function productSizes(p, sel) {
	    if (!p || !Array.isArray(p.variants) || !sel.length) return [];
	    return p.variants
	      .filter(function (v) { return v.inventory > 0 && v.size; })
	      .map(function (v) { return v.size; });
	  }

	  function hasAvailableVariant(p) {
	    if (!p || !Array.isArray(p.variants)) return false;
	    // Pre-order (2026-10-15): a flagged product sells from a pre-book
	    // allocation and may sit at zero between "catalog on" and "inventory
	    // loaded". Keep its card visible; stockLevel() labels it Pre-order.
	    // Zero everywhere on an UNFLAGGED product still means dead: hide it.
	    if (p.preorder) return true;
	    return p.variants.some(function (v) { return v.inventory > 0; });
	  }

	  function cardProduct(card) {
	    return productsById[String(card.getAttribute('data-pid'))] || null;
	  }

	  function syncCardActiveSizes(card) {
	    var selected = isShoeCard(card) ? (state.s || []) : (state.a || []);
	    Array.prototype.forEach.call(card.querySelectorAll('[data-size-chip]'), function (chip) {
	      var value = String(chip.getAttribute('data-size') || '').trim().toUpperCase();
	      var on = selected.some(function (s) {
	        return String(s).trim().toUpperCase() === value;
	      });
	      if (on && !chip.classList.contains('is-out')) chip.setAttribute('aria-current', 'true');
	      else chip.removeAttribute('aria-current');
	    });
	  }

	  /* The CLOSED card's stock chip, repainted to answer "do you have my size?"
	     without the shopper opening the panel. p7-sale.js already renders exactly
	     this on the homepage (cardHTML's stockChip); server-rendered cards carried
	     the stock tier only, which is why the same shopper saw their size on the
	     homepage and lost it on collection, search and the PDP rail.

	     Three states, deliberately identical to p7-sale.js so the two renderers
	     stay interchangeable:
	       - sizes this card stocks   -> pills, dot on the first
	       - a size it does not stock -> "Not in <size>" at the low tier
	       - nothing remembered       -> the tier the server rendered

	     Restore reads data-stock-level / data-stock-label back off the chip
	     rather than caching the original nodes, so a card that arrives late (the
	     related rail) restores identically to one that was there at boot.

	     Cards with no size chips at all are left alone. buildCard()'s overflow
	     cards are the case that matters: they carry no chips, and they only exist
	     while filtering, so the "Not in" branch would label the very cards that
	     were surfaced BECAUSE they stock the size. */
	  function syncCardStockChip(card, selected) {
	    var chip = card.querySelector('[data-stock]');
	    if (!chip) return;
	    if (!card.querySelector('[data-size-chip]')) return;

	    // The card's own chip order, not selection order, so two cards never
	    // disagree about which size comes first.
	    var matched = Array.prototype.slice
	      .call(card.querySelectorAll('[data-size-chip]'))
	      .filter(function (c) { return !c.classList.contains('is-out'); })
	      .map(function (c) { return String(c.getAttribute('data-size') || '').trim(); })
	      .filter(function (size) {
	        return size && selected.some(function (s) {
	          return String(s).trim().toUpperCase() === size.toUpperCase();
	        });
	      });

	    while (chip.firstChild) chip.removeChild(chip.firstChild);

	    if (matched.length) {
	      chip.className = 'card__stock card__stock--active card__stock--pills';
	      chip.setAttribute('aria-label', 'Available in ' + matched.join(', '));
	      matched.forEach(function (size, i) {
	        var pill = document.createElement('span');
	        pill.className = 'card__size-pill';
	        if (i === 0) pill.appendChild(stockDot());
	        pill.appendChild(document.createTextNode(size));
	        chip.appendChild(pill);
	      });
	      return;
	    }

	    var text = document.createElement('span');
	    text.setAttribute('data-stock-text', '');
	    if (selected.length) {
	      chip.className = 'card__stock card__stock--low';
	      text.textContent = 'Not in ' + selected[0];
	    } else {
	      chip.className = 'card__stock card__stock--' + (chip.getAttribute('data-stock-level') || 'high');
	      text.textContent = chip.getAttribute('data-stock-label') || '';
	    }
	    chip.setAttribute('aria-label', text.textContent);
	    chip.appendChild(stockDot());
	    chip.appendChild(text);
	  }

	  function stockDot() {
	    var dot = document.createElement('i');
	    dot.className = 'card__dot';
	    dot.setAttribute('aria-hidden', 'true');
	    return dot;
	  }

	  /* The related rail is a browse prompt, not a filter control: see the
	     comment block in sections/p7-product-related.liquid. Marking its grid
	     [data-p7-cards-annotate-only] lets the remembered size be REFLECTED there
	     (chips, stock chip) while the two filtering behaviours stay off: cards
	     are never hidden, and a chip tap keeps its href to the collection instead
	     of rewriting the stored size. */
	  function annotateOnly(el) {
	    return !!el.closest('[data-p7-cards-annotate-only]');
	  }

	  function filterHasProducts(filter) {
	    if (!payload || !Array.isArray(payload.products)) return false;
	    return payload.products.some(function (p) {
	      return matchesFilterObject(p, filter);
	    });
	  }

	  // Pill count for the mixed-collection filter: sellable products only, so
	  // "Shoes 19" agrees with the cards the pill actually reveals.
	  function filterCount(filter) {
	    if (!payload || !Array.isArray(payload.products)) return 0;
	    return payload.products.filter(function (p) {
	      return hasAvailableVariant(p) && matchesFilterObject(p, filter);
	    }).length;
	  }

	  function matchesFilterObject(p, filter) {
	    if (!filter || filter.key === 'all') return true;
	    if (filter.cat) return productCategory(p) === filter.cat;
	    if (filter.model) return matchesModelFilter(p, filter.model);
	    if (filter.buckets) return matchesBucket(p, filter.buckets);
	    if (filter.elite) return !!p.elite;
	    return true;
	  }

	  function apparelSizeFilters() {
	    var sizes = payload && Array.isArray(payload.apparel_sizes) ? payload.apparel_sizes.slice() : [];
	    return sizes
	      .filter(function (size, index) {
	        return size && sizes.indexOf(size) === index;
	      })
	      .sort(P.sizeCompare)
	      .map(function (size) {
	        return { key: 'apparel-size:' + size, label: size, size: size };
	      });
	  }

	  function selectedSizeChips() {
	    var active = activeSizeState();
	    return (active.s || []).map(function (v) { return { bucket: 's', value: v }; })
	      .concat((active.a || []).map(function (v) { return { bucket: 'a', value: v }; }));
	  }

	  function appendSelectedSizeChips(rail) {
	    selectedSizeChips().forEach(function (c) {
	      var btn = document.createElement('button');
	      btn.type = 'button';
	      btn.className = 'filter-chip filter-chip--size';
	      btn.setAttribute('aria-label', 'Remove size ' + c.value);
	      var x = document.createElement('span');
	      x.className = 'filter-chip__x';
	      x.setAttribute('aria-hidden', 'true');
	      x.textContent = '✕';
	      var label = document.createElement('span');
	      label.textContent = c.value;
	      btn.appendChild(x);
	      btn.appendChild(label);
	      btn.addEventListener('click', function () { removeSize(c.bucket, c.value); });
	      rail.appendChild(btn);
	    });
	  }

	  function renderLocalFilter() {
	    var rail = document.querySelector('[data-clx-local-filter]');
	    if (!rail || !payload || !Array.isArray(payload.products)) return;
	    var mode = pageFilterMode();
	    if (!mode) {
	      rail.hidden = true;
	      return;
	    }
	    while (rail.firstChild) rail.removeChild(rail.firstChild);
	    var sizeSlot = document.createElement('span');
	    sizeSlot.className = 'p7-clx__size-slot';
	    appendSelectedSizeChips(sizeSlot);
	    if (sizeSlot.children.length) rail.appendChild(sizeSlot);

	    var pillSlot = document.createElement('span');
	    pillSlot.className = 'p7-clx__pill-scroll';
	    if (mode === 'apparel-size') {
	      var sizeFilters = apparelSizeFilters();
	      sizeFilters.forEach(function (f) {
	        var btn = document.createElement('button');
	        btn.type = 'button';
	        btn.className = 'pill pill-cat';
	        btn.setAttribute('data-clx-size', f.size);
	        btn.textContent = f.label;
	        if ((state.a || []).some(function (s) { return P.sameSize(s, f.size); })) {
	          btn.classList.add('active');
	          btn.setAttribute('aria-current', 'true');
	        }
	        btn.addEventListener('click', function () {
	          var a = (state.a || []).slice();
	          if (a.some(function (s) { return P.sameSize(s, f.size); })) {
	            a = a.filter(function (s) { return !P.sameSize(s, f.size); });
	          } else {
	            a.push(f.size);
	          }
	          commit({ s: state.s, a: a });
	        });
	        pillSlot.appendChild(btn);
	      });
	      if (pillSlot.children.length) rail.appendChild(pillSlot);
	      rail.hidden = sizeFilters.length === 0 && selectedSizeChips().length === 0;
	      return;
	    }
	    var filterSet = mode === 'model' ? MODEL_FILTERS : mode === 'sale' ? CATEGORY_FILTERS : BUCKET_FILTERS;
	    var filters = filterSet.filter(function (f, i) {
	      return i === 0 || filterHasProducts(f);
	    });
	    if (mode === 'bucket' && filters[0]) {
	      filters[0] = { key: 'all', label: 'All ' + (collectionTitle || collectionHandle) };
	    }
	    filters.forEach(function (f) {
	      var btn = document.createElement('button');
	      btn.type = 'button';
	      btn.className = 'pill pill-cat';
	      btn.setAttribute('data-clx-category', f.key);
      var label = document.createElement('span');
      label.textContent = f.label;
      btn.appendChild(label);
      if (mode === 'sale' && f.key !== 'all') {
        var count = document.createElement('span');
        count.className = 'pill-count';
        count.textContent = String(filterCount(f));
        btn.appendChild(count);
      }
      if (f.key === categoryFilter) {
	        btn.classList.add('active');
	        btn.setAttribute('aria-current', 'true');
	      }
	      btn.addEventListener('click', function () {
	        categoryFilter = f.key;
	        renderLocalFilter();
	        apply();
	      });
	      pillSlot.appendChild(btn);
	    });
	    if (mode === 'model') {
	      var kids = document.createElement('a');
	      kids.className = 'pill pill-cat';
	      kids.href = '/collections/kids';
	      kids.textContent = 'Kids';
	      pillSlot.appendChild(kids);
	    }
	    if (pillSlot.children.length) rail.appendChild(pillSlot);
	    rail.hidden = filters.length <= 1 && selectedSizeChips().length === 0;
	  }

    function titleCase(value) {
      return String(value || '').replace(/[-_]+/g, ' ').replace(/\b\w/g, function (c) {
        return c.toUpperCase();
      });
    }

    function modelLabel(p) {
      var known = {
        cambridge: 'Cambridge',
        telford: 'Telford Low',
        essex: 'Essex',
        manchester: 'Manchester',
        conrad: 'Conrad',
        payload: 'Payload'
      };
      var key = String((p && p.model) || '').trim().toLowerCase();
      return known[key] || titleCase(key) || String((p && p.title) || '');
    }

    function colourLabel(p, name) {
      var title = String((p && p.title) || '').trim();
      var base = String(name || '').trim();
      if (!base || !title) return '';
      var escaped = base.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      return title.replace(new RegExp('^' + escaped + '\\s*-?\\s*', 'i'), '').trim();
    }

    function tierLabel(p) {
      var bucket = String((p && (p.tier || p.bucket)) || '').trim().toLowerCase();
      if (bucket === 'new') return 'New';
      if (bucket === 'sale' || bucket === 'evergreen') return 'Sale';
      if (bucket === 'final' || bucket === 'last-season') return 'Final';
      return '';
    }

    function totalInventory(p) {
      if (!p || !Array.isArray(p.variants)) return 0;
      return p.variants.reduce(function (sum, v) {
        return sum + Math.max(0, Number(v.inventory) || 0);
      }, 0);
    }

    function stockLevel(p) {
      // Pre-order (2026-10-15): flagged products sell real pre-book stock,
      // so a positive count must still read "Pre-order", never "In stock".
      if (p && p.preorder) return { level: 'preorder', label: 'Pre-order' };
      var qty = totalInventory(p);
      // Pre-order (2026-10-14): this JSON lists only products that can be
      // bought (p7-product-json skips the rest), so 0 stock here means the
      // product sells past zero.
      if (qty <= 0) return { level: 'preorder', label: 'Pre-order' };
      if (qty <= 5) return { level: 'low', label: 'Low stock' };
      return { level: 'high', label: 'In stock' };
    }

    // Mirrors the visible shell of p7-card.liquid for filtered products that
    // live beyond the current paginated page. It intentionally skips the size
    // drawer, but keeps the card body height, tier, colour, price and stock row
    // consistent with server-rendered cards.
    function buildCard(p) {
      var li = document.createElement('li');
      li.className = 'p7-clx__cell';
      // Marks this node as our own beyond-the-page render so the late-cards
      // MutationObserver below (host: document.body on a collection page,
      // since there is no recommendations rail to scope to) does not mistake
      // it for a genuinely new card. Left unmarked, appending it would look
      // identical to a late-arriving rail card, apply() would run again,
      // which clears and rebuilds the overflow set, which appends nodes
      // again — an unbounded observer/apply() loop.
      li.setAttribute('data-p7-overflow', '');

      var art = document.createElement('article');
      art.className = 'card';
      art.setAttribute('data-card', '');
      art.setAttribute('data-pid', String(p.id));
      art.setAttribute('data-ptype', p.type === 'shoe' ? 'shoe' : 'apparel');

      var a = document.createElement('a');
      a.className = 'card__frame';
      a.href = p.url;

      if (p.image) {
        var img = document.createElement('img');
        img.src = p.image;
        img.alt = p.title;
        img.loading = 'lazy';
        a.appendChild(img);
      }

      var body = document.createElement('div');
      body.className = 'card__body';

      var tagText = tierLabel(p);
      if (tagText) {
        var tags = document.createElement('p');
        tags.className = 'card__tags';
        var tag = document.createElement('span');
        tag.className = 'card__tag';
        tag.textContent = tagText;
        tags.appendChild(tag);
        body.appendChild(tags);
      }

      var head = document.createElement('div');
      head.className = 'card__head';

      function p7moneyCents(v) {
        // Cents (2026-10-15): round to 2dp; whole prices stay bare, fractional
        // ones keep their cents, so the bag matches what checkout charges.
        var n = Math.round((Number(v) || 0) * 100) / 100;
        var w = Math.floor(Math.abs(n));
        var c = Math.round((Math.abs(n) - w) * 100);
        var s = String(w).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        if (c > 0) s += '.' + (c < 10 ? '0' : '') + c;
        return (n < 0 ? '-' : '') + '$' + s;
      }
      var h = document.createElement('a');
      h.className = 'card__title';
      h.href = p.url;
      var name = modelLabel(p);
      h.textContent = name;

      var price = document.createElement('span');
      price.className = 'card__price';
      if (p.original_price && p.original_price > p.sale_price) {
        var original = document.createElement('s');
        original.textContent = p7moneyCents(p.original_price);
        price.appendChild(original);
      }
      var current = document.createElement('b');
      current.textContent = p7moneyCents(p.sale_price);
      if (p.original_price && p.original_price > p.sale_price) current.className = 'is-sale';
      price.appendChild(current);

      head.appendChild(h);
      head.appendChild(price);
      body.appendChild(head);

      var colour = colourLabel(p, name);
      if (colour) {
        var colourEl = document.createElement('p');
        colourEl.className = 'card__colour';
        colourEl.textContent = colour;
        body.appendChild(colourEl);
      }

      var stock = stockLevel(p);
      var stockRow = document.createElement('div');
      stockRow.className = 'card__stock-row';
      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'card__toggle';
      toggle.setAttribute('aria-expanded', 'false');
      var stockEl = document.createElement('span');
      stockEl.className = 'card__stock card__stock--' + stock.level;
      stockEl.setAttribute('aria-label', stock.label);
      // Mirrors p7-card.liquid so an overflow card restores to the same tier
      // the server would have rendered, rather than to a guess.
      stockEl.setAttribute('data-stock', '');
      stockEl.setAttribute('data-stock-level', stock.level);
      stockEl.setAttribute('data-stock-label', stock.label);
      var dot = document.createElement('i');
      dot.className = 'card__dot';
      dot.setAttribute('aria-hidden', 'true');
      var stockText = document.createElement('span');
      stockText.setAttribute('data-stock-text', '');
      stockText.textContent = stock.label;
      stockEl.appendChild(dot);
      stockEl.appendChild(stockText);
      toggle.appendChild(stockEl);
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('width', '12');
      svg.setAttribute('height', '12');
      svg.setAttribute('viewBox', '0 0 12 12');
      svg.setAttribute('aria-hidden', 'true');
      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'M3 4.5 6 7.5 9 4.5');
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', '1.6');
      path.setAttribute('stroke-linecap', 'round');
      path.setAttribute('stroke-linejoin', 'round');
      svg.appendChild(path);
      toggle.appendChild(svg);
      stockRow.appendChild(toggle);
      body.appendChild(stockRow);

      art.appendChild(a);
      art.appendChild(body);
      li.appendChild(art);
      return li;
    }

    function apply() {
      var active = activeSizeState();
      var selShoe = active.s || [];
      var selApp = active.a || [];
      var visible = 0;
	    var categoryActive = categoryFilter !== 'all';
	    var filtering = selShoe.length > 0 || selApp.length > 0 || categoryActive;

      // A "Next" link under a client-filtered set navigates to an UNFILTERED
      // page 2, which silently discards the filter. p7-sale.js:192-217 is the
      // paginate-free model. Driven by `filtering`, not `visible`, so the nav
      // stays hidden even when a filter empties the page to zero.
      if (pag) pag.hidden = filtering;

	      cards.forEach(function (card) {
	        var sel = isShoeCard(card) ? selShoe : selApp;
	        var p = cardProduct(card);
	        // The category pill is a GRID control. Cards outside #p7-clx-grid
	        // (the top-seller rails above a sale grid, the drop page's carousel)
	        // keep following the size filter but never the category, and never
	        // count toward the collection total: "Apparel" must not empty the
	        // shoes rail or report 111 products when the grid shows 101.
	        var inGrid = !grid || grid.contains(card);
	        var show = (!p || hasAvailableVariant(p)) && (!inGrid || matchesCategory(p)) && P.matches(cardSizes(card), sel);
	        // An annotate-only card still computes `show`, it just does not act
	        // on it, and does not count toward `visible` either, so a rail can
	        // never drive the collection count or the empty state.
	        if (!annotateOnly(card)) {
	          hideTarget(card).hidden = !show;
	          if (show && inGrid) visible++;
	        }
	        syncCardActiveSizes(card);
	        syncCardStockChip(card, sel);
	      });

      // Products beyond the current paginated page. Without this, filtering
      // to size 12 on page 1 hides the eleven 12s that happen to sit on page
      // 3 — the shopper concludes you do not stock their size.
      clearOverflow();
	      if (payload && filtering && grid && Array.isArray(payload.products)) {
	        payload.products.forEach(function (p) {
	          if (onPage[String(p.id)]) return;            // already server-rendered
	          if (!hasAvailableVariant(p)) return;
	          var sel = p.type === 'shoe' ? selShoe : selApp;
	          if (!matchesCategory(p)) return;
	          if (!P.matches(productSizes(p, sel), sel)) return;
	          var node = buildCard(p);
          grid.appendChild(node);
          overflowNodes.push(node);
          visible++;
        });
      }

      var countEl = document.querySelector('[data-clx-count]');
      var emptyEl = document.querySelector('[data-clx-empty]');

      if (countEl) {
        // Lazy capture: countEl's real starting text is the fallback when
        // there is no payload to correct it (search has none) or the
        // payload is missing/malformed — captured on the first sighting,
        // before THIS render overwrites it.
        if (countInitialText === null) countInitialText = countEl.textContent;
        if (filtering) {
          countEl.textContent = visible + (visible === 1 ? ' product' : ' products');
        } else {
          var emitted = readEmittedTotal();
          countEl.textContent = typeof emitted === 'number'
            ? emitted + (emitted === 1 ? ' product' : ' products')
            : countInitialText;
        }
      }
      if (emptyEl) emptyEl.hidden = !(filtering && visible === 0);

      // meta.truncated means the payload itself is incomplete (a collection
      // over Shopify's 250 cap — check-payload-cap.mjs should have caught
      // this at build time). Do not present a filtered-to-zero result as
      // authoritative, and leave pagination up so the rest of the catalogue
      // stays reachable.
      if (payload && payload.meta && payload.meta.truncated) {
        if (emptyEl) emptyEl.hidden = true;
        if (pag) pag.hidden = false;
      }

      // card_index in p7-collection.liquid marks card 1 eager with
      // fetchpriority=high, assuming DOM order is visual order. Once cards
      // are hidden, card 1 may be invisible and that fetch wasted — and if
      // EVERY page-1 card is hidden, the first visible card is one of the
      // overflow nodes just appended above, which buildCard() always renders
      // loading="lazy". Either way, give the real first visible image the
      // eager boost.
      //
      // Exactly one image may carry fetchpriority=high — several cancel the
      // ranking out and defeat the attribute (p7-card.liquid:53-54). The
      // server sets it on card 1; once filtering hides that card the boost has
      // to MOVE, not accumulate, so clear before setting.
      cards.forEach(function (c) {
        var img = c.querySelector('img');
        if (img && img.getAttribute('fetchpriority') === 'high') img.removeAttribute('fetchpriority');
      });
      overflowNodes.forEach(function (n) {
        var img = n.querySelector('img');
        if (img && img.getAttribute('fetchpriority') === 'high') img.removeAttribute('fetchpriority');
      });

      var firstVisible = cards.filter(function (c) { return !hideTarget(c).hidden; })[0];
      var firstImg = firstVisible ? firstVisible.querySelector('img')
        : (overflowNodes[0] ? overflowNodes[0].querySelector('img') : null);
      if (firstImg) {
        firstImg.setAttribute('fetchpriority', 'high');
        firstImg.loading = 'eager';
      }

	      renderRail();
	      renderLocalFilter();
	    }

	    function renderRail() {
	      var rail = document.querySelector('[data-clx-rail]');
	      if (!rail) return;
	      while (rail.firstChild) rail.removeChild(rail.firstChild);
	      rail.hidden = true;
	    }

    function removeSize(bucket, value) {
      var next = { s: (state.s || []).slice(), a: (state.a || []).slice() };
      next[bucket] = next[bucket].filter(function (s) {
        return String(s).trim().toUpperCase() !== String(value).trim().toUpperCase();
      });
      commit(next);
    }

    function commit(next) {
      state = P.normalize(next);
      P.set(state);      // emits p7:size-prefs-change; sync() re-applies
    }

    /* ---- card size chips ---- */
    document.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-size-chip]');
      if (!chip) return;
      var card = chip.closest('[data-card]');
      if (!card) return;
      var size = String(chip.getAttribute('data-size') || '').trim();
      if (!size) return;

      // Annotate-only surfaces reflect the remembered size but never set it.
      // Bail before preventDefault so the chip stays an ordinary link, which
      // is the behaviour p7-product-related.liquid documents for the rail.
      if (annotateOnly(chip)) return;

      // Letter vendor sizing on Shoes-typed products (Owen Slippers S-XXL) is
      // excluded entirely. Routing a letter size into P.toggleShoe would store
      // it in state.s, and since no numerically-sized shoe stocks "M" etc,
      // P.matches would then hide every other shoe in the collection on one
      // tap. Do not fall through to the apparel branch either — the card IS a
      // shoe card, and filtering it against the apparel bucket is wrong too.
      // Bail before preventDefault so the chip behaves as an ordinary link,
      // same as p7-sale.js's homepage handler, where such sizes are absent
      // from state.shoeSizes and the tap is declined the same way.
      if (isShoeCard(card) && !P.isNum(size)) return;

      e.preventDefault();   // the href is the no-JS fallback only

      if (isShoeCard(card)) {
        commit(P.toggleShoe(size, state));
      } else {
        var a = (state.a || []).slice();
        var i = a.findIndex(function (s) {
          return String(s).trim().toUpperCase() === size.toUpperCase();
        });
        if (i === -1) a.push(size); else a.splice(i, 1);
        commit({ s: state.s, a: a });
      }
    });

    function sync(event) {
      state = P.normalize(event && event.detail ? event.detail : P.read());
      apply();
    }

    apply();   // saved sizes auto-apply on landing, even before any cards exist
    document.addEventListener('p7:size-prefs-change', sync);
    document.addEventListener('p7:size-prefs-ready', sync, { once: true });

    /* ---- late cards (the related rail is fetched after DOMContentLoaded) ----
       On a bare product page the rail is the ONLY card surface on the page,
       and at DOMContentLoaded time it has not been fetched yet — cards.length
       is 0 right here, above. Everything in this function still has to run
       (state, the click listener, the pref-change listeners, this observer)
       or a saved size would never reach the rail once its cards do arrive —
       there would be nothing left to notice them.

       p7-recommendations.js (sections/p7-product-related.liquid) swaps its
       fetched markup into [data-p7-recommendations-content] via
       appendChild, so that is the real, tightly-scoped host to watch. There
       is no [data-related-root] anywhere in this theme. */
    var host = document.querySelector('[data-p7-recommendations-content]') || document.body;
    if (window.MutationObserver) {
      new MutationObserver(function (records) {
        var added = false;
        records.forEach(function (r) {
          Array.prototype.forEach.call(r.addedNodes, function (n) {
            if (n.nodeType !== 1) return;
            // Our own overflow cards (see buildCard's data-p7-overflow) are not
            // "late" cards — apply() already knows about them via
            // overflowNodes. Treating them as late would re-trigger apply(),
            // which rebuilds the overflow set, which re-triggers this
            // observer: runaway on collection/search, where host falls back
            // to document.body.
            if (n.matches('[data-p7-overflow]') || n.querySelector('[data-p7-overflow]')) return;
            if (n.matches('[data-card]') || n.querySelector('[data-card]')) added = true;
          });
        });
        if (!added) return;
        // Mirrors the addedNodes guard above: an overflow card is not a
        // "late" card either, so it must not join `cards` — that array is
        // meant to hold only server/rail-rendered cards (buildCard()'s
        // fetchpriority clearing loop above walks it on that assumption).
        cards = Array.prototype.slice
          .call(document.querySelectorAll('[data-card]'))
          .filter(function (c) { return !c.closest('[data-p7-overflow]'); });
        apply();
      }).observe(host, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
